import React, { Fragment, useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";
import {
  TextField,
  FormControl,
  OutlinedInput,
  Input,
  InputLabel,
  InputAdornment,
} from "@material-ui/core";

// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { login, auth } from "../../actions/auth";
import { sendCartToServer } from "../../actions/cart";
import { cartDataUpdate } from "../../actions/cart";

//components
// import BreadCrumb from "../../components/breadcrumb/breadcrumb";

import Alert from "../../components/alert/alert.component";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: "25ch",
  },
}));

const Login = (props) => {
  const [values, setValues] = useState({
    loading: false,
    email: "",
    password: "",
    amount: "",
    password: "",
    weight: "",
    weightRange: "",
    showPassword: false,
    abc: "",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // componentDidMount() {
  //   window.scrollTo(0, 0);
  // }
  const onSubmit = async (e) => {
    e.preventDefault();

    setValues({ ...values, loading: true });

    const data = {
      email: values.email,
      password: values.password,
    };
    console.log(data);
    const loginRes = await props.login(data);
    console.log(loginRes);

    const res = await props.auth();

    if (res) {
      const cartProductData = JSON.parse(localStorage.getItem("cart"));

      const dataToSend = [];
      cartProductData &&
        cartProductData.map((item) => {
          dataToSend.push(item.item._id);
        });
      const objectToSend = {
        products: dataToSend,
      };
      const ServerCartRes = await props.sendCartToServer(objectToSend);
      if (ServerCartRes) {
        cartDataUpdate(ServerCartRes.data);
      }
    }

    if (localStorage.getItem("checkout") === true) {
      props.history.push("/checkout");
    }

    if (!res) {
      setValues({ ...values, loading: false });
    }
  };

  const handleChange = (event) => {
    console.log(event);
    setValues({ ...values, [event.target.name]: event.target.value });
    // setState({ ...values.values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    if (values.showPassword === false) {
      setValues({ ...values, showPassword: true });
    } else {
      setValues({ ...values, showPassword: false });
    }
  };

  /* const handleClickShowPassword = () => {
    if (values.showPassword === false) {
      setValues({ showPassword: true });
    } else {
      setValues({ showPassword: false });
    }
  }; */

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const { isAuth } = props._auth;
  // to show password or hide
  // const classes = useStyles();
  // const [values, setValues] ...values,= React.useState({
  //   amount: '',
  //   password: '',
  //   weight: '',
  //   weightRange: '',
  //   showPassword: false,
  // });

  // end show password or hide

  return isAuth && !props._auth.loading ? (
    <Redirect
      exact
      to={localStorage.getItem("checkout") ? "/checkout" : "/dashboard"}
    />
  ) : (
    <Fragment>
      <div className="create-an-account">
        <div className="regester-top">
          <div className="container">
            <div className="row mx-md-5">
              <header className="col-md-12" id="create-acc-header">
                <span className="secure-login">
                  Secure Login <i className="fa fa-lock" />
                </span>
              </header>
            </div>
          </div>
        </div>
        <div className="create-account">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div id="acc-container">
                  <div className="create-acc-heading">
                    <h3>Login</h3>
                  </div>
                  <Alert />
                  <form
                    id="registerForm"
                    onSubmit={(e) => {
                      onSubmit(e);
                    }}
                  >
                    <FormControl variant="outlined" className="my-2">
                      <InputLabel htmlFor="component-outlined">
                        Email
                      </InputLabel>
                      <OutlinedInput
                        id="component-outlined"
                        label="Email"
                        className="create-acc-inp"
                        autoComplete="email"
                        onChange={(e) => {
                          setValues({ ...values, email: e.target.value });
                        }}
                      />
                    </FormControl>
                    <FormControl variant="outlined" className="my-2">
                      <InputLabel htmlFor="outlined-adornment-password">
                        Password
                      </InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-password"
                        type={values.showPassword ? "text" : "password"}
                        value={values.password}
                        autoComplete="new-password"
                        name="password"
                        onChange={(e) => {
                          setValues({
                            ...values,
                            password: e.target.value,
                          });
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {values.showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        labelWidth={70}
                      />
                    </FormControl>
                    <div className="create-acc-btn">
                      <button type="submit" className="create-acc">
                        Login
                      </button>
                    </div>
                    <div className="form-footer">
                      <p className="hav-acc">
                        Don’t have an account?{" "}
                        <Link to={"/register"} id="signIn-acc">
                          Sign Up
                        </Link>
                      </p>
                      <p className="hav-acc">
                        Forget Your Password?{" "}
                        <Link to={"/forget-password"} id="signIn-acc">
                          Forget Password
                        </Link>
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
login.propTypes = {
  login: PropTypes.func.isRequired,
};

auth.propsTypes = {
  auth: PropTypes.func.isRequired,
};

sendCartToServer.propsTypes = {
  sendCartToServer: PropTypes.func.isRequired,
};
cartDataUpdate.propsTypes = {
  cartDataUpdate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  _auth: state.auth,
});
export default connect(mapStateToProps, {
  login,
  auth,
  sendCartToServer,
  cartDataUpdate,
})(Login);
